import { render, staticRenderFns } from "./InterviewAssignDialog.vue?vue&type=template&id=18ccc77f&scoped=true"
import script from "./InterviewAssignDialog.vue?vue&type=script&lang=js"
export * from "./InterviewAssignDialog.vue?vue&type=script&lang=js"
import style0 from "./InterviewAssignDialog.vue?vue&type=style&index=0&id=18ccc77f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ccc77f",
  null
  
)

export default component.exports